<template>
  <v-container flat>
    <v-row>
      <v-col cols="12" md="6">
        <!-- <v-subheader class="subheading">Company Name</v-subheader> -->
        <v-text-field
          v-model="companyName"
          label="Company Name"
          outlined
          filled
          :append-outer-icon="
            this.account.company.name === companyName ? null : 'mdi-floppy'
          "
          @click:append-outer="updateCompany()"
          :readonly="currentUser.role === 'user'"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <!-- <v-subheader class="subheading">API KEY</v-subheader> -->
        <v-text-field
          :append-icon="showAPIKey ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showAPIKey ? 'text' : 'password'"
          name="input-10-2"
          label="API KEY"
          outlined
          filled
          :value="apiKey"
          class="input-group--focused"
          @click:append="fetchAPIKey()"
          readonly
          hint="Use this API key to send appointment requests from your website, directly into BRID.AL  <a>View Documentation</a>"
          persistent-hint
        ></v-text-field>
      </v-col>
    </v-row>

    <v-subheader class="subheading">Logo</v-subheader>
    <v-container>
      <vue-dropzone
        v-if="(!imgSrc && !img) || changingImage"
        id="logo"
        :options="dropzoneOptions"
        :useCustomSlot="true"
        v-on:vdropzone-file-added="fileAdded"
      >
        <div class="dropzone-custom-content">
          <h3 class="dropzone-custom-title">Drag and drop to upload image!</h3>
          <div class="subtitle">...or click to select a file from your computer</div>
          <v-btn v-if="changingImage" color="error" @click.stop="cancelChangeImg()">Cancel</v-btn>
        </div>
      </vue-dropzone>

      <v-row v-if="!changingImage">
        <v-col cols="12" sm="6">
          <v-card style="display:flex;justify-content:center" flat color="transparent">
            <v-btn v-if="editingImage" @click="resetImg()">Change Image</v-btn>
            <v-btn v-if="!editingImage" color="secondary" @click="editImg()">Edit Image</v-btn>
            <v-btn v-if="editingImage" color="error" @click="cancelImg()">Cancel</v-btn>
          </v-card>
          <v-img v-if="img && !editingImage" :src="img"></v-img>
          <div
            v-if="imgSrc"
            style="width: 100%; height:300px; border: 1px solid gray; display: inline-block;"
          >
            <vue-cropper
              ref="cropper"
              :guides="true"
              :view-mode="2"
              drag-mode="crop"
              :auto-crop-area="0.75"
              :min-container-width="250"
              :min-container-height="180"
              :background="true"
              :rotatable="true"
              :src="imgSrc"
              preview=".preview"
              alt="Source Image"
              :img-style="{ width: '100%', height: '300px' }"
            ></vue-cropper>
          </div>
          <v-btn v-if="imgSrc" block color="secondary" @click="cropImage()">Crop</v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <v-subheader v-if="imgSrc" class="subheading">Preview</v-subheader>
          <div v-if="imgSrc" class="preview" style="width: 100%;height:300px;overflow:hidden"></div>
        </v-col>
      </v-row>

      <!-- <div class="preview" style="overflow: hidden;height:200px;width:300px"></div> -->
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: {
    vueDropzone: vue2Dropzone,
    VueCropper
  },
  data() {
    return {
      companyName: "",
      apiKey: "***************************",
      showAPIKey: false,
      editingImage: false,
      changingImage: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailHeight: 200,
        thumbnailMethod: "contain",
        addRemoveLinks: true,
        maxFiles: 1
      },
      imgSrc: "",
      img: null
    };
  },
  methods: {
    ...mapActions({
      addImage: "account/addImage",
      getApiKey: "account/getApiKey",
      getURL: "documents/getURL"
    }),
    fetchAPIKey() {
      if (this.showAPIKey) {
        this.showAPIKey = false;
        this.apiKey = "***************************";
      } else {
        this.getApiKey().then(key => {
          this.apiKey = key;
          this.showAPIKey = true;
        });
      }
    },
    fileAdded(file) {
      if (!file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          this.changingImage = false;
          this.editingImage = true;
          console.log(this.imgSrc);
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    resetImg() {
      this.editingImage = false;
      this.changingImage = true;
      this.imgSrc = "";
    },
    async editImg() {
      this.editingImage = true;

      var url = await this.getURL(this.logo);
      var im = await this.getDataUri(url);
      this.imgSrc = im;

      // this.$nextTick(() => {
      //   this.$refs.cropper.setData(result.data);
      // });
    },
    getDataUri(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous"); //getting images from external domain
        img.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = this.naturalWidth;
          canvas.height = this.naturalHeight;
          //next three lines for white background in case png has a transparent background
          var ctx = canvas.getContext("2d");
          ctx.fillStyle = "#fff"; /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          canvas.getContext("2d").drawImage(this, 0, 0);
          var data = canvas.toDataURL("image/jpeg");
          resolve(data);
        };
        img.onerror = reject;
        img.src = url;
      });
    },
    cancelImg() {
      this.editingImage = false;
      this.imgSrc = "";
    },
    cancelChangeImg() {
      this.editingImage = false;
      this.imgSrc = "";
      this.changingImage = false;
    },
    cropImage() {
      // this.img = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // formData.append('file', this.$refs.cropper.getCroppedCanvas().toDataURL())
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        const formData = new FormData();
        formData.append("image", blob);

        this.addImage(formData).then(() => {
          this.editingImage = false;
          this.imgSrc = "";
          this.changingImage = false;
        });
      });
    },
    async getImage() {
      this.img = await this.getURL(this.logo);
    },
    init() {
      this.companyName = this.account.company.name;
      if (this.logo) {
        this.getImage();
      }
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    logo() {
      return this.account.company.logo;
    },

    currentUser() {
      return this.account.user;
    },
    company() {
      return this.account.company;
    }
  },
  watch: {
    company(val) {
      console.log(val);
      this.init();
    }
  },
  mounted() {
    this.init();
  }
};
</script>
